// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__t57W9","chip__text":"Chip_chip__text__XI+je","chip__delete":"Chip_chip__delete__RS11u"};